import { Injectable, inject } from '@angular/core';

import { BetBuilderConfig, EpcotConfig } from '@frontend/sports/common/client-config-data-access';

@Injectable({ providedIn: 'root' })
export class BetBuilderConfigService {
    private betbuilderConfig = inject(BetBuilderConfig);
    private epcotConfig = inject(EpcotConfig);

    isBetBuilderEnabled(sportId: number): boolean {
        return (
            this.betbuilderConfig.isBetBuilderEnabled &&
            (this.betbuilderConfig.isBetBuilderEnabledForSport?.includes(sportId) || this.useBetBuilderInEntainUI(sportId))
        );
    }

    editIconButtonOverride(): boolean {
        return this.betbuilderConfig.editIconButtonOverride;
    }

    isEntainUiOverlayEnabled(): boolean {
        return this.betbuilderConfig.showEntainUiInOverlay;
    }

    useBetBuilderInEntainUI(sportId: number): boolean {
        return (this.betbuilderConfig.useBetBuilderInEntainUI?.includes(sportId) ?? false) && this.betbuilderConfig.isBetBuilderEnabled;
    }

    showEntainUiInOverlay(sportId?: number): boolean {
        if (!sportId || !this.useBetBuilderInEntainUI(sportId)) {
            return false;
        }

        return this.betbuilderConfig.showEntainUiInOverlay;
    }

    // the difference to `showEntainUiInOverlay` is that it enables additional behaviour:
    // replacing quick bet drawer with betbar, betbuilder notification message,
    // betbuilder selection error in betslip, onboarding tooltip & dialog, etc
    showEmbeddedUi(): boolean {
        return this.epcotConfig.isEnabled;
    }
}
